/* eslint-disable */
const $ = jQuery.noConflict();
'use strict';

const Checkout = {
	shippingUpdate: false,
	allowUpdate: false,

	init: function() {
		if (!window.location.pathname.includes('/checkout')) {
			return;
		}

		this.bindEvents();
		this.initPayment();
		this.watchForFallbackLabel();
	},

	isAddressComplete: function() {
		const useShipping = $('#ship-to-different-address-checkbox').is(':checked');
		const prefix = useShipping ? '#shipping_' : '#billing_';
		const requiredFields = ['country', 'state', 'postcode', 'city', 'address_1'];

		for (let i = 0; i < requiredFields.length; i++) {
			const $field = $(`${prefix}${requiredFields[i]}`);
			if (!$field.length || !$field.val()) {
				return false;
			}
		}
		return true;
	},

	watchForFallbackLabel: function() {
		const container = document.body;

		const updateVisibility = () => {
			const label = document.querySelector("label[for='shipping_method_0_flexible_shipping_ups6fallback']");
			const allShippingMethods = document.querySelectorAll('#js-shipping_method li');
			if (!label) return;
			if (Checkout.isAddressComplete() && allShippingMethods.length === 1) {
				label.classList.add('show');
			} else {
				label.classList.remove('show');
			}
		};

		// Immediately attempted once
		updateVisibility();

		// Watch DOM while Label does not appear
		const observer = new MutationObserver(() => {
			updateVisibility();
		});
		observer.observe(container, {
			childList: true,
			subtree: true,
		});
	},

	initPayment: function() {
		const accountPayment2 = $('#order_review');
		if (accountPayment2.length > 0) {
			$(document).ajaxStop(function() {
				const cardNumber = {
					border: '2px solid #cfcfcf',
					backgroundColor: '#fff',
					padding: '12px 10px 13px 24px',
					maxWidth: '100%',
					width: '75%',
					height: '30px',
					'font-size': '16px',
					fontFamily: 'degular, Georgia, serif',
				};

				const cvvNum = {
					border: '2px solid #cfcfcf',
					backgroundColor: '#fff',
					padding: '12px 10px 13px 24px',
					height: '30px',
					width: '75%',
					'font-size': '16px',
					fontFamily: 'degular, Georgia, serif',
				};
				// eslint-disable-next-line no-undef
				setIfieldStyle('card-number', cardNumber);
				// eslint-disable-next-line no-undef
				setIfieldStyle('cvv', cvvNum);
			});
		}
	},

	bindEvents: function() {
		Checkout.allowUpdate = true;
		$('#checkout-shipping-methods').append('<ul id="js-shipping_method"></ul>');
		$('#checkout-shipping-methods').on('click', function() {
			Checkout.shippingUpdate = true;
		});
		$(document).on('update_checkout', function() {
			// Show loader by modifying the pseudo-element
			$('.woocommerce-shipping-methods').addClass('is-active');

			// Check if the shipping methods should update
			Checkout.loadShippingMethods();

			// Setting a timeout when to enable the shipping updating.
			setTimeout(() => {
				Checkout.allowUpdate = true;
			}, 1)
			setTimeout(() => {
				Checkout.loadShippingMethods();
			}, 2000)
			Checkout.shippingUpdate = false;
		});
	},

	loadShippingMethods: function() {
		if (!Checkout.shippingUpdate && Checkout.allowUpdate) {
			$('#js-shipping_method').empty();

			// Show loader before loading
			$('.woocommerce-shipping-methods').addClass('is-active');

			$('#js-shipping_method').load(location.href + ' #js-shipping_method', function() {
				// Hide loader when shipping methods are loaded
				$('.woocommerce-shipping-methods').removeClass('is-active');
			});

			Checkout.allowUpdate = false;
		}
	}
}

export default Checkout;
